import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import CommonDivWidget from "components/CommonDivWidget/CommonDivWidget";
import { message, Spin, DatePicker, Row, Col, Pagination } from "antd";
import CommonButton from "components/ButtonWidgets/CommonButton/CommonButton";
import { TitleSearch } from "components/SearchWidget/TitleSearch";
import { useHistory } from "react-router-dom";
import { UpdateCurrentRoot } from "redux/actions/appActions";
import TableWidget from "./TableWidget/TableWidget";
import { showAddVideoListDialog } from "./AddVideoListPage/showAddVideoListDialog";
import {
  apiCreateVideo,
  apiDeleteVideo,
  apiGetVideoList,
  apiUpdateVideo,
} from "services/videoListService";
const { RangePicker } = DatePicker;

function VideoListPage() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isBusy, setIsBusy] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [searchList, setSearchList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    setIsBusy(true);
    apiGetVideoList(currentPage, pageSize, startDate, endDate)
      .then((data) => {
        setIsBusy(false);
        setDataList(data.dataList)
        setSearchList(data.dataList)
        setTotalCount(data.total_count);
      })
      .catch((err) => {
        setIsBusy(false);
        setDataList([])
        setSearchList([])
        message.error("Sorry! " + err);
      });
  }, [pageSize, currentPage, startDate, endDate]);

  const onShowSizeChange: PaginationProps["onShowSizeChange"] = (
    current,
    pageSize
  ) => {
    setPageSize(pageSize);
    setCurrentPage(current);
  };
  const onChange: PaginationProps["onChange"] = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearch = (searchText) => {
    const tmpList = dataList.filter((info) =>
      info.name.toLowerCase().includes(searchText)
    );
    setSearchList([...tmpList]);
  };
  const handleChange = (event) => {
    if (event.target.value === "") {
      setSearchList(dataList);
    } else {
      handleSearch(event.target.value);
    }
  };

  const handleDateFilter = (startDate, endDate) => {
    setCurrentPage(1);
    setStartDate(startDate);
    setEndDate(endDate);
  };
  const onNewVideo = async () => {
    var res = await showAddVideoListDialog({
      title: "New Video",
      isEditing: false,
    });
    if (res === null) return;
    setIsBusy(true);
    apiCreateVideo(res)
      .then((data) => {
        setIsBusy(false);
        if (data === null) {
          message.error("There's something wrong while adding New Video");
        }
        var tmpData = dataList;
        let updateData = [...dataList];
        updateData.splice(tmpData.length, 0, data);
        tmpData = [...updateData];
        setDataList(tmpData);
        setSearchList(tmpData);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error("Error! " + err);
      });
  };
  const onClickDelete = (pInfo) => {
    setIsBusy(true);
    apiDeleteVideo(pInfo.id)
      .then((data) => {
        setIsBusy(false);
        let updateData = [...dataList];
        var storeIndex = updateData.findIndex((x) => x.id == pInfo.id);
        updateData.splice(storeIndex, 1);
        var tmpData = [...updateData];
        setDataList(tmpData);
        setSearchList(tmpData);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };
  const onClickDetail = (pInfo) => {};
  const onClickEdit = async (pInfo) => {
    let info = pInfo;
    var res = await showAddVideoListDialog({
      title: "Edit Item",
      record: info,
      isEditing: true,
    });
    if (res === null) return;

    setIsBusy(true);
    apiUpdateVideo(res)
      .then((data) => {
        setIsBusy(false);
        if (data === null) {
          message.error(
            "There's something wrong while updating a Video"
          );
        }
        let updateData = [...dataList];
        var storeIndex = updateData.findIndex((x) => x.id == data.id);
        updateData.splice(storeIndex, 1, data);
        setDataList(updateData);
        setSearchList(updateData);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };

  return (
    <CommonDivWidget>
      <Spin spinning={isBusy}>
        <h1>Video List</h1>
        <Row>
          <Col>
            <div style={{ fontFamily: "mediumFont", padding: 20 }}>
              Date Filter Period : &nbsp;&nbsp;
              <RangePicker
                size={"default"}
                onChange={(e, date) => {
                  if (date == null) {
                    handleDateFilter("", "");
                  } else {
                    handleDateFilter(date[0], date[1]);
                  }
                }}
              />
            </div>
          </Col>
          <Col flex={"auto"}>
            <div style={{ fontFamily: "mediumFont", padding: 20 }}>
              <TitleSearch
                onSearch={handleSearch}
                onChange={handleChange}
                onPressEnter={handleSearch}
              />
            </div>
          </Col>

          <Col>
            <div style={{ fontFamily: "mediumFont", padding: 20 }}>
              <CommonButton
                onClick={() => {
                  onNewVideo();
                }}
              >
                New
              </CommonButton>
            </div>
          </Col>
        </Row>
        <Row justify={"center"} style={{ paddingTop: 16 }}>
          <Col>
            <Pagination
              showSizeChanger
              onShowSizeChange={onShowSizeChange}
              onChange={onChange}
              defaultCurrent={1}
              current={currentPage}
              total={totalCount}
              pageSize={pageSize}
            />
          </Col>
        </Row>

        <div style={{ paddingTop: 32 }}>
          <TableWidget
            dataList={searchList}
            onDetailAction={onClickDetail}
            onUpdateAction={onClickEdit}
            onDeleteAction={onClickDelete}
          />
        </div>
      </Spin>
    </CommonDivWidget>
  );
}

export default VideoListPage;
